import _ from 'underscore';

/**
 * @method shouldDisplay
 * @param {Array} settings array of strings, displaySetting permission identifiers
 * @param {Array} list array of displaySetting objects
 */
const shouldDisplay = (settings, list) => {
  const identifiers = _.pluck(list, 'identifier');
  return _.intersection(identifiers, settings).length > 0;
};
export default {
  shouldDisplay
};